import { AuditTrailRepository } from '../ports/AuditTrailRepository';
import { AuditTrailResult } from '../domain/entities/AuditTrailResult';

export class FetchAuditTrailUseCase {
  constructor(private readonly auditTrailRepository: AuditTrailRepository) {}

  async execute(i9FormId: string, detailedDigitization = false): Promise<AuditTrailResult> {
    return this.auditTrailRepository.fetchAuditTrail(i9FormId, detailedDigitization);
  }
}
